import queryString from 'query-string';
import React from 'react';
import CountUp from 'react-countup';
import { FaArrowDown, FaArrowUp, FaFire } from 'react-icons/fa';
import { useHistory } from 'react-router-dom';
import { Card, CardBody } from 'reactstrap';
import vendorAssign from '../../../../../../assets/custom/v2/vendor.svg';
import { AiOutlinePercentage } from 'react-icons/ai';

const StatusPartnerCard = ({ statusBooking, cardData, filter, nextNavigation }) => {
  const history = useHistory();

  const totalCount =
    cardData?.[statusBooking?.name]?.data?.totalCount || cardData?.[statusBooking?.name]?.data?.totalCount === 0
      ? Number(cardData?.[statusBooking?.name]?.data?.totalCount)
      : null;

  const routeHandler = () => {
    const params = {
      name: statusBooking?.name,
      type: statusBooking?.type,
      ...(!filter?.timelineFilter && { startDate: filter?.startDate, endDate: filter?.endDate }),
      nextNavigation: nextNavigation,
    };
    if (statusBooking?.nextNavigation) {
      history.push({
        pathname: '/v2/booking',
        search: `?${queryString.stringify(params)}`,
      });
    }
  };

  return (
    <Card
      style={{
        border: '1px solid #FFFFFF',
        borderRadius: '20px',
        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.15)', // Added boxShadow
        cursor: statusBooking?.nextNavigation && 'pointer',
      }}
      className="partner-card"
      onClick={routeHandler}
    >
      <CardBody>
        <div className="d-flex justify-content-between">
          <div>
            {/* <FaFire className="icon-fire" size={20} color="#EA9C2B" /> */}
            <img src={statusBooking?.icon ? statusBooking?.icon : vendorAssign} className="img-fluid" alt="" style={{ width: '50px' }} />
          </div>
          <div>
            <p className="m-0" style={{ fontWeight: '500', fontSize: '18px' }}>
              {statusBooking?.displayName}
            </p>
            <div style={{ textAlign: 'end' }}>
              {totalCount != null ? (
                <CountUp
                  separator=""
                  className="fw-bold"
                  start={0}
                  end={totalCount}
                  duration={2}
                  style={{ fontSize: '25px', fontWeight: '700 !important', color: '#8E8E8E' }}
                />
              ) : (
                <p className="fw-bold text-format-3 m-0">-</p>
              )}
            </div>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

export default StatusPartnerCard;
